import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useLang } from "../context/LangContext";

const STRINGS = {
  ca: {
    legal: "Legal",
    privacy: "Privacitat",
    cookies: "Galetes",
    legal_notice: "Avís legal",
    terms: "Termes",
    sitemap: "Mapa del lloc",
    rights: "Tots els drets reservats.",
  },
  es: {
    legal: "Legal",
    privacy: "Privacidad",
    cookies: "Cookies",
    legal_notice: "Aviso legal",
    terms: "Términos",
    sitemap: "Mapa del sitio",
    rights: "Todos los derechos reservados.",
  },
  en: {
    legal: "Legal",
    privacy: "Privacy",
    cookies: "Cookies",
    legal_notice: "Legal notice",
    terms: "Terms",
    sitemap: "Sitemap",
    rights: "All rights reserved.",
  },
};

export function Footer() {
  const { lang } = useLang();
  const s = STRINGS[lang] || STRINGS.es;
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-16 border-t border-brand-tan/25 bg-brand-cream/70"
      data-testid="footer"
    >
      <div className="mx-auto max-w-6xl px-6 md:px-12 py-12 grid gap-10 md:grid-cols-[1fr_2fr]">
        <div>
          <Logo size="md" />
          <p className="mt-4 text-[10px] tracking-[0.4em] uppercase font-bold text-brand-tan max-w-[28ch]">
            Experiències culturals a Catalunya
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-sm">
          <FooterLink to="/legal/privacy" testid="foot-privacy">{s.privacy}</FooterLink>
          <FooterLink to="/legal/cookies" testid="foot-cookies">{s.cookies}</FooterLink>
          <FooterLink to="/legal/legal-notice" testid="foot-legal">{s.legal_notice}</FooterLink>
          <FooterLink to="/legal/terms" testid="foot-terms">{s.terms}</FooterLink>
          <FooterLink to="/sitemap" testid="foot-sitemap">{s.sitemap}</FooterLink>
        </div>
      </div>
      <div className="border-t border-brand-tan/20 px-6 md:px-12 py-5 mx-auto max-w-6xl flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-[10px] tracking-[0.3em] uppercase font-bold text-brand-tan">
        <span>© {year} Aristeia Cultural SL · {s.rights}</span>
        <span>Barcelona · Catalunya</span>
      </div>
    </footer>
  );
}

function FooterLink({ to, children, testid }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className="block text-brand-brown/80 hover:text-brand-brown transition-colors"
    >
      <span className="text-[10px] tracking-[0.3em] uppercase font-bold text-brand-tan block">
        ·
      </span>
      <span className="font-bold">{children}</span>
    </Link>
  );
}

export default Footer;
